import { useEffect, useRef } from "react";
import { useQueryClient } from "react-query";
import dayjs from "dayjs";
import { getGoogleCalendarStatus } from "../api/client";
import { runGoogleCalendarSyncToCompletion } from "../utils/googleCalendarSync";

const MIN_SYNC_INTERVAL_MS = 5 * 60 * 1000;
const SESSION_KEY = "agenda-google-sync-at";

function unwrapStatus(res) {
  if (res && typeof res === "object" && "data" in res) return res.data;
  return res;
}

/**
 * Dispara sync em background ao abrir a agenda (no máx. a cada 5 min por aba).
 * Se houver importação incompleta (cursor), retoma na hora — sem esperar o intervalo.
 */
export function useAgendaGoogleAutoSync(enabled = true) {
  const queryClient = useQueryClient();
  const ranRef = useRef(false);

  useEffect(() => {
    if (!enabled || ranRef.current) return;
    ranRef.current = true;

    (async () => {
      try {
        const r = await getGoogleCalendarStatus();
        const status = unwrapStatus(r) ?? {};
        if (!status.connected || !status.syncEnabled || status.needsReauth) return;

        const inProgress = Boolean(status.syncing);
        if (!inProgress) {
          const lastLocal = Number(sessionStorage.getItem(SESSION_KEY) || 0);
          if (Date.now() - lastLocal < MIN_SYNC_INTERVAL_MS) return;
          if (status.lastSyncAt) {
            const last = dayjs(String(status.lastSyncAt).replace(" ", "T"));
            if (last.isValid() && Date.now() - last.valueOf() < MIN_SYNC_INTERVAL_MS) return;
          }
        }

        await runGoogleCalendarSyncToCompletion({
          forceFullSync: false,
          onChunk: () => {
            queryClient.invalidateQueries(["user-agenda"]);
          },
        });
        sessionStorage.setItem(SESSION_KEY, String(Date.now()));
        queryClient.invalidateQueries(["user-agenda"]);
        queryClient.invalidateQueries(["google-calendar-status"]);
      } catch {
        /* sync em background — falha silenciosa */
      }
    })();
  }, [enabled, queryClient]);
}
